<template>
  <div class="quick-list">
    <div v-for="(item, index) in list" 
         :key="item.caseId" 
         class="item" 
         @click="handleJump(item, index)" 
         :data-sensors-exposure-property-product_code="item.config?item.config.configId:''"
         data-sensors-exposure-property-product_type="diversion"
         data-sensors-exposure-event-name="Diversion_Exposure" 
         data-sensors-exposure-property-element_positon="product_icon"
    >
      <img class="img" :src="item.icon" :style="them">
      <p class="text">{{ item.title }}</p>
    </div>
  </div>
</template>

<script>
import { getKey } from '../../assets/utils'
export default {
  name: 'quick-list',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    // 对于埋点需要的参数
    position: {
      type: String,
      default: ''
    },
    them: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    list (value) {
      value && value.forEach((item, index) => {
        this.$report({
          id: 10297,
          args: {
            status: 'icon',
            position: this.position,
            target: item.config && item.config.configId,
            type: index
          }
        })
      })
    }
  },
  methods: {
    handleJump (item, index) {
      const token = getKey('userInfo', 'token')
      this.$report({
        id: 10296,
        args: {
          position: this.position,
          target: item.config && item.config.configId,
          type: index
        }
      })
      if (token && item.config) {
        this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: 'product_icon', product_code: item.config.configId })
        this.$router.push({ path: '/river/middle', query: { ...(item.config || {}) } })
      } else {
        this.$router.push(`/landing/river?configId=${item.config.configId}`)
      } 
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.quick-list{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 26px 40px 10px;
  .item{
    width: 150px;
    text-align: center;
    margin-top: 23px;
    .img{
      width: 96px;
      height: 96px;
    }
    .text{
      font-size: 28px;
      color: #333333;
      margin-top: 15px;
      line-height: 40px;
      font-weight: 400;
    }
  }
}
</style>